import styled from 'styled-components';

const DashGrid = styled.div`
  display: grid;
  grid-template-rows: 50px 50px 1fr 50px;
  min-height: 100%;
`;

const DashContent = styled.div``;

export { DashGrid, DashContent };



// WEBPACK FOOTER //
// ./src/components/UI/DashUI.tsx